import { render, staticRenderFns } from "./VueFormBuilder.vue?vue&type=template&id=526ccd5a"
import script from "./VueFormBuilder.vue?vue&type=script&lang=ts"
export * from "./VueFormBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports